<div class="d-flex align-items-center">
  <div class="fw-bold text-primary font-weight-medium m-0">Filter position</div>
  <div *ngIf="loading" class="spinner-grow spinner-grow-sm ms-3" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <select class="form-select m-0 ms-auto" [(ngModel)]="filter_position" (ngModelChange)="handleChange($event)" style="width: 130px">
    <option [value]="option.id" *ngFor="let option of options">{{ option.text }}</option>
  </select>
</div>
